var React = require('react');

function Docs (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.92 18.336C16.032 17.472 18.72 16.896 21.888 16.704C21.888 16.608 21.888 12.96 21.888 5.66402C21.888 5.37602 21.696 5.18402 21.408 5.18402C18.72 5.28002 15.936 5.85602 13.248 7.10402C13.248 7.10402 13.248 10.752 13.248 17.856C13.248 18.144 13.44 18.336 13.728 18.336C13.824 18.432 13.92 18.432 13.92 18.336Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.752 18.336C8.64 17.472 5.952 16.896 2.784 16.704C2.784 16.608 2.784 12.96 2.784 5.66402C2.784 5.37602 2.976 5.18402 3.264 5.18402C5.952 5.28002 8.736 5.85602 11.424 7.10402C11.424 7.10402 11.424 10.752 11.424 17.856C11.424 18.144 11.232 18.336 10.944 18.336C10.848 18.432 10.752 18.432 10.752 18.336Z","fill":"#9596AC","key":1})]);
}

Docs.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Docs;

Docs.default = Docs;
